/**
 * Login handoff. No password form, no local user table: identity is delegated
 * to Logto over OIDC with PKCE. The server never sees a password.
 */
export function LoginPage() {
  return (
    <div className="mkt" style={{ background: 'var(--bg)' }}>
      <div className="card" style={{ maxWidth: 520, margin: '80px auto', boxShadow: 'var(--shadow-2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="9" stroke="#0a5fae" strokeWidth="2" />
            <circle cx="12" cy="12" r="3.5" fill="#0a5fae" />
          </svg>
          <h2>Sign in</h2>
        </div>
        <p style={{ color: 'var(--ink-2)', marginBottom: 20 }}>
          PlasticVision uses your Sensifai account. You will be redirected to
          Logto to authenticate and then returned here.
        </p>
        <a className="btn primary" href="/login">
          Continue with Sensifai
        </a>
        <div className="card-note">
          New accounts are provisioned with the Operator role and no
          organisation. An organisation administrator assigns your site and role
          — your tenant is never guessed from your email domain.
        </div>
      </div>
    </div>
  );
}
